import type { BackendRouteDefinition } from '../types';
import type { UpdateIdentity } from '@cloudFunctions/functions/payments/updateIdentity';

export interface UpdateIdentityRequestData {
  identityId: UpdateIdentity.RequestData['identityId'];
  body: Omit<UpdateIdentity.RequestData, 'identityId'>;
}

/**
 * Kept isolated so the Phase 3 admin Finix migration can flip this route's
 * transport without touching shared admin route tables.
 */
export const updateIdentityRoute = {
  transport: 'api',
  method: 'POST',
  path: '/admin/finix/identities/:identityId',
  params: (requestData: UpdateIdentityRequestData) => ({
    identityId: requestData.identityId,
  }),
  body: (requestData: UpdateIdentityRequestData) => requestData.body,
} as const satisfies BackendRouteDefinition;
